var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 219,
    height: 1865,
    viewBox: "0 0 219 1865",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.0366 5H-30.2852",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6113 23.5972H-93.8594",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8009 42.0942H-43.0508",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M117.638 60.6909H-116.887",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8009 79.188H-43.0508",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5238 97.7852H-19.7734",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75997 116.282H-8.76172",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2971 134.879H-41.3008",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M156.432 153.376H-155.434",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3341 171.973H-70.582",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M180.711 190.47H-179.711",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3127 209.067H-51.3086",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M153.178 227.564H-152.18",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M132.654 246.161H-131.906",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3341 264.658H-70.582",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5266 283.255H-22.5273",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M148.671 301.852H-147.926",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M214 320.349H-213",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3518 338.946H-86.3516",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0366 357.443H-30.2852",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0199 376.041H-18.0234",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M137.16 394.537H-136.41",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M42.548 413.134H-41.8008",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M132.654 431.631H-131.906",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0366 450.229H-30.2852",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0199 468.726H-18.0234",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6113 487.322H-93.8594",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8009 505.819H-43.0508",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M117.638 524.417H-116.887",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8009 542.914H-43.0508",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5238 561.51H-19.7734",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75997 580.007H-8.76172",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2971 598.604H-41.3008",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M156.432 617.202H-155.434",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3341 635.699H-70.582",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M180.711 654.295H-179.711",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3127 672.792H-51.3086",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M153.178 691.39H-152.18",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M132.654 709.887H-131.906",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3341 728.483H-70.582",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5266 746.98H-22.5273",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M148.671 765.578H-147.926",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M214 784.075H-213",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3518 802.672H-86.3516",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0366 821.169H-30.2852",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0199 839.766H-18.0234",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M137.16 858.263H-136.41",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M42.548 876.86H-41.8008",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M132.654 895.457H-131.906",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0366 913.954H-30.2852",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0199 932.551H-18.0234",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6113 951.048H-93.8594",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8009 969.645H-43.0508",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M117.638 988.142H-116.887",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8009 1006.74H-43.0508",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5238 1025.24H-19.7734",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75997 1043.83H-8.76172",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2971 1062.33H-41.3008",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M156.432 1080.93H-155.434",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3341 1099.42H-70.582",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M180.711 1118.02H-179.711",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3127 1136.52H-51.3086",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M153.178 1155.12H-152.18",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M132.654 1173.71H-131.906",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3341 1192.21H-70.582",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5266 1210.81H-22.5273",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M148.671 1229.3H-147.926",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M214 1247.9H-213",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3518 1266.4H-86.3516",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0366 1284.99H-30.2852",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0199 1303.49H-18.0234",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M137.16 1322.09H-136.41",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M42.548 1340.58H-41.8008",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M132.654 1359.18H-131.906",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0366 1377.68H-30.2852",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0199 1396.28H-18.0234",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6113 1414.77H-93.8594",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8009 1433.37H-43.0508",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M117.638 1451.87H-116.887",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8009 1470.46H-43.0508",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5238 1489.06H-19.7734",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75997 1507.56H-8.76172",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2971 1526.16H-41.3008",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M156.432 1544.65H-155.434",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3341 1563.25H-70.582",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M180.711 1581.75H-179.711",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3127 1600.34H-51.3086",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M153.178 1618.84H-152.18",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M132.654 1637.44H-131.906",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3341 1655.93H-70.582",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5266 1674.53H-22.5273",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M148.671 1693.03H-147.926",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M214 1711.63H-213",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3518 1730.12H-86.3516",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0366 1748.72H-30.2852",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0199 1767.32H-18.0234",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M137.16 1785.81H-136.41",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M42.548 1804.41H-41.8008",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M132.654 1822.91H-131.906",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0366 1841.5H-30.2852",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0199 1860H-18.0234",
    stroke: "#7630FF",
    strokeOpacity: 0.25,
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.0dc46f4cba4953f3084a0407b65b3015.svg";
export { ForwardRef as ReactComponent };